// import React from 'react';

// function OrderDetail() {
//   return (
//     <div className="order-details-container">
//       <div className="order-details">
//         <h2 lassName='heading-order'>Order Details</h2>
//         {/* Order details content here */}
//       </div>
//       <div className="customer-details">
//         <h2 className='heading-order'>Customer Details</h2>
//         {/* Customer details content here */}
//       </div>
//     </div>
//   );
// }

// export default OrderDetail;
import React from 'react';

function OrderDetails() {
  return (
    <div className="order-details-container">
      <div className="order-details">
        <h2 className='heading-order'>Order Details</h2>
        <div className="detail-row">
          <span className="labelsss">Order ID:</span>
          <span className="value">ORD-12345</span>
        </div>
        <div className="detail-row">
          <span className="labelsss">Order Date:</span>
          <span className="value">2024-04-18</span>
        </div>
        <div className="detail-row">
          <span className="labelsss">Order Status:</span>
          <span className="value">Pending</span>
        </div>
        {/* Add more details here */}
      </div>
      <div className="customer-details">
        <h2 className='heading-order'>Customer Details</h2>
        <div className="detail-row">
          <span className="labelsss">Customer Name:</span>
          <span className="value">John Doe</span>
        </div>
        <div className="detail-row">
          <span className="labelsss">Email:</span>
          <span className="value">johndoe@example.com</span>
        </div>
        <div className="detail-row">
          <span className="labelsss">Phone Number:</span>
          <span className="value">(555) 555-5555</span>
        </div>
        {/* Add more details here */}
      </div>
    </div>
  );
}

export default OrderDetails;
